

export const frontMatter = {
	sidebar_position: 2,
	license: 'republish',
	author: 'Jan van Steenbergen',
	custom_edit_url: '/501',
	last_update: {
		author: 'Google Translate'
	},
	origin: 'http://steen.free.fr/interslavic/history.html'
};
export const contentTitle = 'Kratka medslovanska zgodovina';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-sl-docusaurus-plugin-content-docs-current-learn-misc-history-md-a70.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    code: "code",
    em: "em",
    h1: "h1",
    header: "header",
    li: "li",
    ol: "ol",
    p: "p",
    span: "span",
    strong: "strong",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "kratka-medslovanska-zgodovina",
        children: "Kratka medslovanska zgodovina"
      })
    }), "\n", _jsx(_components.p, {
      children: "Zgodovina medslovanskega jezika je tesno povezana s panslavizmom, ideologijo, ki verjame, da so Slovani en narod in si prizadeva za njihovo kulturno in politično združitev. Skupaj z idejo o skupni slovanski državi prihaja tudi ideja o skupnem slovanskem jeziku. Že od začetka je bilo vprašanje, kakšen naj bo ta jezik."
    }), "\n", _jsxs(_components.p, {
      children: ["Močan kandidat je bila vedno ", _jsx(_components.strong, {
        children: "ruščina"
      }), ", po številu govorcev daleč največji slovanski jezik. Danes je materni jezik skoraj polovice Slovanov, (skoraj) tekoče pa ga govori še 15–20 %. Poleg tega je bila Rusija vedno ogromen imperij, regionalna velesila in je edina slovanska država z neprekinjeno tradicijo državnosti. Ni presenetljivo, da so ruščino kot panslovanski jezik zagovarjali večinoma ruski panslavisti, ki so vedno zelo jasno poudarjali, da je ruska hegemonija conditio sine qua non za slovansko državo, in ravno zaradi tega ideja nikoli ni nastala. veliko priljubljenost med manjšimi slovanskimi narodi. Čeprav priznavajo svoje kulturne vezi z Rusijo, nočejo biti obravnavani kot »iznakaženi Rusi« in večina jih nima najboljših izkušenj z rusko nadvlado. Poleg tega ruščina ni preprost jezik in ima številne značilnosti, zaradi katerih je govorcem drugih slovanskih jezikov težko razumljiva."]
    }), "\n", _jsxs(_components.p, {
      children: ["Drug priljubljen kandidat je ", _jsx(_components.strong, {
        children: "stara cerkvena slovanščina"
      }), ", najstarejši zapisani slovanski jezik, ki sta ga v 9. stoletju kodificirala (ali ustvarila, po mnenju nekaterih) brata sv. Ciril in sv. Metod. Ta jezik ima več prednosti: zelo tesno je povezan s skupnim prednikom slovanskih jezikov in ima dolgo tradicijo uporabe v pravoslavni liturgiji, zato je skupna podlaga in skupni vpliv za mnoge slovanske jezike. Ima dodatno prednost, da ni nikogaršnji materni jezik, tako da ga je mogoče zlahka predstaviti kot nevtralen, mednarodni jezik, podoben latinščini ali sanskrtu. Kljub tem prednostim pa ima stara cerkvena slovanščina tudi nekaj praktičnih pomanjkljivosti. Dejstvo, da je bil postavljen kot sveti jezik, ga je naredilo še posebej odpornega proti spremembam, tako da so tudi poznejše »redakture« komaj kaj več kot izvirnik z nekaj ", _jsx(_components.em, {
        children: "couleur locale"
      }), ". Posledično ima stara cerkvena slovanščina obilno bogato pravopis, ki vsebuje več črk in glasov, ki so izginili iz uporabe, prav tako bogato in zato zapleteno slovnico ter izjemno arhaično besedišče, ki vsebuje besede, ki se niso ohranile v nobenem od sodobnih jezikov, vendar nima besed za sodobne pojme. Juraj Križanić, verjetno prvi panslavist, je že v 17. stoletju ugotovil, da je stara cerkvena slovanščina postala preveč arhaična, da bi bila izvedljiva kot panslovanski jezik. Z drugimi besedami, zahtevalo bi temeljito posodobitev in tu nastopi ", _jsx(_components.strong, {
        children: "medslovanščina"
      }), ". Medslovanščina se, lahko bi rekli, začne tam, kjer se stara cerkvena slovanščina konča."]
    }), "\n", _jsxs(_components.p, {
      children: ["Križanić je bil prvi, ki je dejansko opisal jezik, ki ga je, da bi ugodil carju, poimenoval ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Ruski"
        })
      }), ", v resnici pa je bil mešanica ruske cerkvene slovanščine in hrvaščine ter elementov iz drugih slovanskih jezikov, zlasti poljščine. Dokončan je bil leta 1666 in se pogosto navaja kot prvi zgrajeni medslovanski jezik. V kasnejših letih so njegovemu zgledu sledili številni drugi. V 19. stoletju, ko je bil panslavizem na vrhuncu, je ugledalo luč še deset projektov čeških, slovaških, slovenskih in hrvaških avtorjev. Med njimi so bili najbolj dodelani: ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Universalis Lingua Slavica"
        })
      }), ", ki ga je leta 1826 izdal Slovak Ján Herkeľ, jezik, ki temelji predvsem na zahodnoslovanskih jezikih; ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Vsjeslovianьskyь"
        })
      }), ", na cerkvenoslovanski osnovi in izdal 1861 Čeh Vaceslav Bambas; in ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Uzajemni Pravopis Slavjanski"
        })
      }), ", izdal 1865 Slovenec Matija Majar-Ziljski. Medtem ko je bila večina projektov namenjena oživitvi in posodobitvi (stare) cerkvene slovanščine, se je Majar odločil za povsem drugačen pristop. Njegov projekt je temeljil na ideji, da bi lahko Slovani postali bolj razumljivi drugim Slovanom, pri čemer bi za izhodišče vzeli svoj jezik in ga nato postopoma spreminjali. Prvi korak v tem procesu je bila sprememba pravopisa, ki je povzročil generični (»vzajemni«) panslovanski pravopis. Kasneje je predlagal slovnico, ki je temeljila na jezikovni primerjavi petih glavnih slovanskih jezikov tistega časa: ruščine, poljščine, češčine, srbščine in stare cerkvene slovanščine."]
    }), "\n", _jsxs(_components.p, {
      children: ["V 20. stoletju se je pojavilo več novih projektov, večinoma čeških avtorjev. Medtem ko so bili prejšnji projekti večinoma akademske ekstrapolacije, je težava postala tudi preprostost. Nekateri projekti, kot so ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Neposlava"
        })
      }), " Vsevoloda Cheshikhina, ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slavski"
        })
      }), " Bohumila Holýja in ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovio"
        })
      }), " Marka Hučka, so bili pod močnim vplivom esperanta. Po drugi strani pa je naravoslovni ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Mežduslavjanski jezik"
        })
      }), " Ladislava Podmeleta iz petdesetih let prejšnjega stoletja temeljil predvsem na ruščini, verjetno zaradi politične realnosti tistega časa."]
    }), "\n", _jsxs(_components.p, {
      children: ["Čeprav je bila večina prej omenjenih projektov dodelanih in uporabljenih v različnih publikacijah, so bili osamljeni poskusi posameznih ljudi in zdi se malo verjetno, da bi kateri od njih kdaj imel veliko privržencev. Digitalna doba je medslovanščini odprla številne nove možnosti. Najprej so vse večje možnosti za interakcijo z ljudmi v drugih državah, na poštnih seznamih, internetnih forumih itd. vzbudile ponovno zanimanje za jezik, ki bi bil razumljiv Slovanom različnih narodnosti. Drugič, medslovanščina ni bila več domena jezikoslovcev in panslavistov in vsakdo je imel zdaj možnost deliti svoje ideje na internetu. In tretjič, zahvaljujoč novim komunikacijskim sredstvom avtorji niso bili več prisiljeni delati v izolaciji. Tako smo v prvih letih 21. stoletja priča premiku od samostojnih projektov k skupnim projektom, čemur sledi težnja po njihovem povezovanju. Prvi skupni projekt se je imenoval ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovo"
        })
      }), ", aktiven je bil v letih 2001-2002, a je bil nato ukinjen."]
    }), "\n", _jsx(_components.p, {
      children: "Skupni projekti so imeli nekaj večjih prednosti pred samostojnimi projekti. Prejšnji projekti, ne glede na to, kako dobro so bili zgrajeni, so bili vedno obarvani z narodnostno pripadnostjo avtorjev, med katerimi je bila večina tradicionalno Čehov, Slovencev in Hrvatov. Prvič so začeli igrati vlogo tudi prispevki Rusov, Poljakov, Srbov in Bolgarov. Ker so bili ljudje različnih narodnosti med seboj v stalnem stiku in so imeli dostop do istih virov, je bilo mogoče storiti nekaj, česar doslej še ni bilo, namreč zgraditi Medslovanski slovar. Poleg tega je imel jezikovni projekt, ki ga je delal kolektiv namesto posamezen avtor, takoj na voljo rudimentarno skupnost uporabnikov in poligon za testiranje."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski project"
        })
      }), " se je začel marca 2006, delno kot odgovor na zelo umetno naravo Slovia, takrat edinega aktivnega slovanskega sestavljenega jezika. Temeljil je na enakem konceptu jezikovne primerjave, kot ga je uporabil tudi Majar-Ziljski. Upoštevani so bili vsi živeči slovanski jeziki z najmanj 1 milijonom govorcev, tako da so zahodno, vzhodno in južno slovanščino obravnavali enako. V zgodnjih dneh projekta so avtorji eksperimentirali z različnimi različicami jezika. ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski-P"
        })
      }), " (črka ", _jsx(_components.code, {
        children: "P"
      }), " se nanaša na besedo ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "en",
        children: "pidgin"
      }), " ali ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "prosti"
      }), ", slovansko besedo za \"preprost\"), ki jo je najprej predlagal Ondrej Rečnik, kasneje pa jo je sprejel Gabriel Svoboda, naj bi postala zelo poenostavljen jezik , zgrajen po podobnih načelih kot jeziki pidgin. ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski-N"
        })
      }), " (črka ", _jsx(_components.code, {
        children: "N"
      }), " pomeni „naturalizem“), ki ga je sprožil Jan van Steenbergen in kasneje razdelal Igor Polyakov, je temeljil na vsem, kar je skupno slovanskim jezikom, vključno z njihovim padežnim sistemom. Končno je ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski-S"
        })
      }), " (črka ", _jsx(_components.code, {
        children: "S"
      }), " pomeni \"shematizem\") prizadevanje Gabriela Svobode (", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "GS-Slovianski"
        })
      }), ") in Igorja Poljakova (", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovjanskaj"
        })
      }), "), da bi ustvarila jezik, ki bi združeval shematizem z naturalizmom. Vsi trije so delovali kot ločeni sestrski projekti ali »narečja«, ki so temeljili na različnih slovničnih modelih, vendar so si delili isto pravopisje, fonologijo in besedišče. Postopoma sta bila ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski-S"
        })
      }), " in ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski-P"
        })
      }), " opuščena in leta 2009 je bilo odločeno, da bo ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski-N"
        })
      }), " nosilo ime ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski"
        })
      }), ", medtem ko bo ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski-P"
        })
      }), " še naprej obstajal kot njegova poenostavljena različica, uporabna za komunikacijo z Bolgari , Makedonci in Neslovani."]
    }), "\n", _jsxs(_components.p, {
      children: ["Medtem so bila ločena prizadevanja za premostitev vrzeli med ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski"
        })
      }), " in ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovio"
        })
      }), " s kombinacijo (spremenjene oblike) slovnice ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski"
        })
      }), " z ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovio's"
        })
      }), " večjim slovarjem. Leta 2008 je Rus Hellerick predlagal ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Rozumio"
        })
      }), ", o čemer je zapisal:"]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: [_jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: _jsx(_components.strong, {
            children: "Rozumio"
          })
        }), " ni jezik, temveč poskus združevanja dveh slovanskih pomožnih konlangov ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: _jsx(_components.strong, {
            children: "Slovio"
          })
        }), " in ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: _jsx(_components.strong, {
            children: "Slovianski"
          })
        }), ". Jezik temelji na ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: _jsx(_components.strong, {
            children: "Slovio"
          })
        }), ", vendar ga lahko štejemo za neke vrste ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: _jsx(_components.strong, {
            children: "Slovianski"
          })
        }), " v svoji primitivni obliki."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Enako idejo so februarja 2009 prevzeli tudi Steeven Radzikowski, Andrej Moraczewski in Michal Borovička, ko so začeli nov projekt, najprej imenovan ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slavju Slovio"
        })
      }), " („", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slavic Slovio"
        })
      }), "“) in kmalu poimenovan ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovioski"
        })
      }), ". Za razliko od Rozumia se je Slovioski hitro razvil v ločen jezikovni projekt. Prvotna ideja je bila nadomestiti slovnico ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovio's"
        })
      }), " z bolj naturalistično, medtem ko se je v bistvu držal slovarja ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovio"
        })
      }), ". Tako kot ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski"
        })
      }), ", ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovioski"
        })
      }), "  je imel tri različice ali »nivoje«: ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Prostij Slovioski"
        })
      }), ", ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Srednij Slovioski"
        })
      }), "  in ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Polnij Slovioski"
        })
      }), ". Slednji je bil praktično identičen ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski"
        })
      }), ". Leta 2010 je bil ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Srednij Slovioski"
        })
      }), " ukinjen, slovar ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovio"
        })
      }), " opuščen, sam Slovioski pa se je preimenoval v ", _jsx(_components.strong, {
        children: "Interslovan"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Za vse različice ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski"
        })
      }), " in ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovioski"
        })
      }), " velja, da je nanje močno vplivalo prepričanje, da mora biti pomožni jezik preprost. Celo ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski-N"
        })
      }), " – kljub temu, da je imel spol in primere – je imel zelo poenostavljen sistem za sklanjanje samostalnikov in spreganje glagolov. Vendar sta oba projekta pokazala vse večjo težnjo po dajanju prednosti naravnim rešitvam pred preprostostjo. Tako je v obeh projektih na koncu prevladal naturalistični element. Ta premik k naturalizmu se je še bolj okrepil, ko je na sceno stopil nov projekt: ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Novoslovienskij"
        })
      }), " („", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Neoslavonic"
        })
      }), "“), ki ga je leta 2010 objavil Vojtěch Merunka. Za razliko od ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski"
        })
      }), " in ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovioski"
        })
      }), " je temeljil neposredno na stari cerkveni slovanščini, ki jo je poskušal posodobiti s poenostavitvijo njene ortografije in razširitvijo s sodobnim besediščem, vzetim iz ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski"
        })
      }), ", hkrati pa je ohranil arhaične elemente, kot so več preteklih časov in dvojina ."]
    }), "\n", _jsxs(_components.p, {
      children: ["Vsi trije projekti so od takrat med seboj tesno sodelovali, leta 2011 pa je bil ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Medžuslovjanski"
        })
      }), " („Interslavic“) izbran za skupni vzdevek. Sadovi tega sodelovanja so bili med drugim skupni slovar, skupni novičarski portal in skupni wiki. Ker se je poudarek vedno bolj premikal od preprostosti k prilagodljivosti, se je ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski"
        })
      }), " razvil iz jezika s fiksnimi pravili v bolj prilagodljiv jezik s prototipno ortografijo, ki jo je bilo mogoče zlahka pretvoriti glede na potrebe, dvema različnima slovničnima nivojema in različnimi možnostmi ", _jsx(_components.a, {
        href: "/sl/learn/vocabulary/flavourisation",
        children: "aromatizacije"
      }), ". Ta večnivojska slovnica je vključevala zelo poenostavljen slovnični model, ", _jsx(_components.strong, {
        children: "Slovianto"
      }), ", ki je bil razvit za zamenjavo ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski-P"
        })
      }), " in ", _jsx(_components.strong, {
        children: "Prostij Slovioski"
      }), ", ter naprednejšo slovnico, ki je temeljila na ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Slovianski"
        })
      }), ", Novosloviensky in drugih starejših projektov in namenjen njihovemu povezovanju. Takrat je Slovioski kot ločen projekt prenehal obstajati."]
    }), "\n", _jsxs(_components.p, {
      children: ["V naslednjih letih sta se ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Medžuslovjanski"
        })
      }), " in ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Novoslovienskij"
        })
      }), " (kmalu preimenovana v ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Novoslověnsky"
        })
      }), ") postopoma približevala drug drugemu. Njihove skupnosti uporabnikov so večinoma sestavljali isti ljudje, ki so pogosto mešali elemente obeh projektov. Posledično je večina razlik med obema projektoma izginila po naravni poti."]
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["in 2. junija 2017 je v Staré Město blizu Uherské Hradiště na Češkem potekala Prva konferenca o medslovanskem jeziku (", _jsx(_components.a, {
          href: "http://cisla.slavic-union.org/",
          children: "CISLa 2017"
        }), "), ki je del četrte izvedbe festivala Dnevi slovanske kulture. S 64 udeleženci iz 12 različnih držav je konferenca postala mejnik v zgodovini medslovanstva, saj je bila prvič uporabljena med uradnim, javnim dogodkom. To je bila tudi edinstvena priložnost za preizkušanje jezika: večina predstavitev in razprav je potekala bodisi v medslovanščini bodisi prevajanih v medslovanščino, kar se je izkazalo za dovolj, da so vsi slovanski udeleženci – tudi Poljaki in Bolgari – razumeli tako rekoč vse. Izjemen in dokaj nepričakovan stranski učinek je bil, da je nekaj udeležencev, ki se nikoli niso učili medslovanskega jezika, med konferenco nenadoma začelo govoriti."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Drugi izid konference je bil, da sta se glavna avtorja obeh projektov, Jan van Steenbergen in Vojtěch Merunka, odločila popolnoma združiti svoja projekta, saj je delo z dvema podobnima, vendar ne enakima standardoma postalo neprijetno. Takoj po konferenci so ustanovili komisijo s tremi drugimi tekočimi govorci medslovanskega jezika (Roberto Lombino, Michał Swat in Pavel Skrylev), katerih naloga je bila odkriti in odpraviti vse razlike med obema slovnicama. Do konca julija je bila ta naloga opravljena. Po združitvi je ime jezika postalo ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: _jsx(_components.strong, {
          children: "Medžuslovjansky"
        })
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Od tega trenutka naprej je nova, enotna medslovanščina doživela hiter razmah. Istega leta je bila ustanovljena znanstvena revija ", _jsx(_components.a, {
        href: "http://slovjani.info/",
        children: "Slovjani.info"
      }), ", v kateri so članki napisani v medslovanskem jeziku ali pa jim sledi povzetek v medslovanskem jeziku. Maja 2018 je na Češkem potekala druga konferenca s 67 udeleženci. V istem obdobju je bila medslovanščina predstavljena na več mednarodnih konferencah, med drugim v Podgorici, Poznanu, Lodžu in Moskvi."]
    }), "\n", _jsxs(_components.p, {
      children: ["Še en mejnik je sledil septembra 2019, ko je bil film Václava Marhoula ", _jsx(_components.a, {
        href: "http://steen.free.fr/interslavic/the_painted_bird.html",
        children: "Poslikana ptica"
      }), " ", _jsx(_components.em, {
        children: "(po istoimenskem romanu Jerzyja Kosińskega)"
      }), " premierno prikazan na 76. filmskem festivalu v Benetkah. Za ustvarjanje vtisa nedoločene slovanske države je bila večina dialogov napisana v medslovanščini. Film je bil hvaljen od kritikov, prejel je številne nagrade in postal češki kandidat za oskarja leta 2020. Češki premieri filma je sledila medslovanska mini konferenca v Pragi."]
    }), "\n", _jsxs(_components.p, {
      children: ["Oglaševanje v drugi polovici leta 2019 je povzročilo velik razmah medslovanske skupnosti. V šestih mesecih je glavno zbirališče na [Facebook] ", _jsx(_components.a, {
        href: "https://www.facebook.com/groups/interslavic",
        children: "5"
      }), " naraslo s 1900 na 9000 članov iz 100 držav."]
    }), "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

